import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['input'];

    connect() {
        if (this.element.nodeName === 'INPUT') {
            throw new Error('The phone controller must be applied to a container element with target or an infinite loop will occur.');
        }

        if (!this.hasInputTarget) {
            throw new Error('The phone controller must have an input target.');
        }

        if (this.inputTarget.name) {
            throw new Error('The phone controller input target must not have a name attribute, use data-name.');
        }

        if (!this.inputTarget.dataset?.name) {
            throw new Error('The phone controller input target should have a data-name attribute.');
        }

        this.load();
    }

    async load() {
        const intlTelInput = (await import('intl-tel-input')).default;
        const hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = this.inputTarget.dataset.name;
        this.element.appendChild(hidden);

        const intl = intlTelInput(this.inputTarget, {
            initialCountry: 'lt',
            nationalMode: this.inputTarget.dataset.nationalMode !== 'false',
            preferredCountries: ['lt', 'lv', 'ee'],
            onlyCountries: [
                'lt',
                'de',
                'fr',
                'it',
                'gb',
                'se',
                'es',
                'ua',
                'nl',
                'lv',
                'pl',
                'no',
                'dk',
                'ie',
                'ee',
                'fi',
                'pt',
                'hu',
                'gr',
                'cz',
                'is',
                'be',
                'ch',
                'sk',
                'at',
                'se',
                'mt',
                'hr',
                'lu',
                'cy',
                'ro',
                'si',
                'pt',
                'cy',
            ],
            separateDialCode: false,
            utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js',
            customPlaceholder(selectedCountryPlaceholder, selectedCountryData) {
                if (selectedCountryData.iso2 === 'lt') {
                    return '6xxxxxxx';
                } else if (selectedCountryData.iso2 === 'lv') {
                    return '2xxxxxxx';
                } else if (selectedCountryData.iso2 === 'ee') {
                    return '5xxxxxxx';
                }

                return selectedCountryPlaceholder;
            },
        });

        intl.telInput.addEventListener('countrychange', () => {
            hidden.value = intl.getNumber();
        });

        intl.telInput.addEventListener('change', () => {
            hidden.value = intl.getNumber();
        });

        if (this.inputTarget.dataset.value) {
            intl.promise.then(() => {
                intl.setNumber(this.inputTarget.dataset.value);
                hidden.value = intl.getNumber();
            });
        }

        this.inputTarget.addEventListener('blur', () => {
            hidden.value = intl.getNumber();
        });
    }
}
